import React from "react";
import { Tranquiluxe } from "uvcanvas";
import styles from "./background.module.css";

const Background = () => {
  return <Tranquiluxe className={styles.background} />;
};

export default Background;
